import styled from 'styled-components';

export const DividerStyle = styled.div`
  width: 100%;
  height:1px;
  margin: 26px 0px;
  background-color: #E7EBEC;

  ${({marginBottom}) =>
  marginBottom &&
  `
    margin-bottom: ${marginBottom}px;
    `
  }

`;



// WEBPACK FOOTER //
// ./src/components/Divider/styledComponents.js